'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactShare = require('react-share');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ShareFacebookButton = require('./ShareFacebookButton.scss');var styles = _interopRequireWildcard(_ShareFacebookButton);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton;

var ShareFacebookButton = function ShareFacebookButton(props) {var _ref =
  props.sharingData || {},sharingUrl = _ref.sharingUrl;var
  title = props.title,handleClick = props.handleClick;
  var onShareWindowClose = props.onShareWindowClose || function () {};

  return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.shareButton, props.className), onClick: handleClick },
      _react2.default.createElement(FacebookShareButton, {
          url: sharingUrl,
          onShareWindowClose: onShareWindowClose },

        _react2.default.createElement('span', null, title),
        _react2.default.createElement('span', { className: 'icon icon-facebook' }))));



};

ShareFacebookButton.propTypes = {
  sharingData: _propTypes2.default.object,
  title: _propTypes2.default.string,
  handleClick: _propTypes2.default.func,
  onShareWindowClose: _propTypes2.default.func,
  className: _propTypes2.default.string };exports.default =


ShareFacebookButton;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareFacebookButton/ShareFacebookButton.js
// module id = 2922
// module chunks = 0